import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { LocationPros } from "../../../../types/baseTypes";
import { setUseCaseLocations } from "../../../../redux/slice/booking/bookingSlice";
import {
  bookingCreationCompleted as resetBookingCreation,
  setUseCase,
} from "../../../../redux/slice/bookingCreation/bookingCreationSlice";
import { bookingCreationCompleted as resetApartmentBooking } from "../../../../redux/slice/apartmentRental/apartmentRentalSlice";

interface BookingFlowLifecycleArgs {
  useCase: string;
  locations: LocationPros[] | undefined;
}

// Owns the mount-init / unmount-cleanup contract for the room-rental and
// venue-reservation dialogs. Closes the three lifecycle leaks documented
// in PR #805 review §1, §2: setUseCase, setUseCaseLocations, and the
// booking-slice resets all happened on mount but never on unmount.
export const useBookingFlowLifecycle = ({
  useCase,
  locations,
}: BookingFlowLifecycleArgs) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setUseCase({ useCase }));

    return () => {
      dispatch(setUseCaseLocations([]));
      dispatch(setUseCase({ useCase: null }));
      dispatch(resetBookingCreation());
      dispatch(resetApartmentBooking());
    };
    // useCase is part of the dialog's identity; if it changes the consumer
    // must remount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (locations) {
      dispatch(setUseCaseLocations(locations));
    }
  }, [locations, dispatch]);
};
